const features = [
  {
    icon: 'ri-shield-check-line',
    title: '信息核实保障',
    desc: '每条爆料内容均经过编辑团队多轮交叉验证，确保真实可靠。我们建立了完善的信息审核流程，杜绝虚假信息传播。',
    color: 'bg-primary-50 text-primary-500',
  },
  {
    icon: 'ri-flashlight-line',
    title: '全天候极速更新',
    desc: '7×24小时不间断监测全网信息，第一时间捕捉有价值爆料线索并发布，让您始终走在资讯前沿。',
    color: 'bg-accent-50 text-accent-600',
  },
  {
    icon: 'ri-stack-line',
    title: '多领域全覆盖',
    desc: '涵盖社会热点、科技行业、金融动态、娱乐圈、房产楼市等十余个领域，一站式满足您的爆料资讯需求。',
    color: 'bg-secondary-100 text-secondary-700',
  },
  {
    icon: 'ri-lock-line',
    title: '隐私安全保护',
    desc: '采用严格的数据加密与隐私保护机制，投稿人信息绝对保密，支持匿名发布，让您放心分享爆料内容。',
    color: 'bg-primary-50 text-primary-500',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 lg:px-8 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="text-xs font-label font-semibold text-primary-500 uppercase tracking-wider">
            平台优势
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mt-2 mb-3">
            为什么选择51爆料
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-2xl mx-auto">
            四大核心优势，打造值得信赖的爆料资讯平台
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {features.map((f) => (
            <div
              key={f.title}
              className="flex flex-col p-6 rounded-xl bg-background-50 border border-background-200/70"
            >
              <div className={`w-12 h-12 flex items-center justify-center rounded-xl ${f.color} mb-5`}>
                <i className={`${f.icon} text-xl`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-2.5">{f.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}